import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LIB_CONFIG, LibConfig } from '../../lib.config';
import { SucheError } from './suche-error';

@Injectable({
  providedIn: 'root'
})
export class EntgeltatlasClient {
  private readonly http = inject(HttpClient);
  private readonly libConfig = inject<LibConfig>(LIB_CONFIG);

  public static SERVER_ERROR = 'SUCHE_EGA_SERVER_ERROR';

  /**
   *  Holt anhand einer DkzId den primären Median vom Entgeltatlas
   */
  public getPrimaererMedian(dkzId: number): Observable<string> {
    return this.http
      .get(`${this.libConfig.entgeltatlasHost}/ct/v1/primaerer-median/${dkzId}`, {
        responseType: 'text'
      })
      .pipe(
        catchError((error) => {
          throw new SucheError(EntgeltatlasClient.SERVER_ERROR, error);
        })
      );
  }
}
